import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const getInboundConsolidationMetrics = unaryRpc({
  name: "getInboundConsolidationMetrics" as const,
  input: z.object({
    returnsCenterId: z.string().optional(),
    startDate: z.date().optional(),
    endDate: z.date().optional(),
  }),
  output: z.object({
    collecting: z.number(),
    preparing: z.number(),
    readyToShip: z.number(),
    fulfilled: z.number(),
  }),
});

export type InboundConsolidationMetricsOutput = z.infer<
  (typeof getInboundConsolidationMetrics)["output"]
>;
